import React from 'react';
import { LinkText, Modal, Typography } from "../ecosystem";
import { translateText } from "../../helpers/data";
import { withTranslation } from 'react-i18next';

const FindCareFormTerms = ({
    termsModalOpen,
    toggleTermsModal,
    variant = 'primary',
    translate,
    t
}) => {

    const textColor = variant === 'primary' ? '' : '$color-primary-c1';
    const linkColor = variant === 'primary' ? undefined : '$color-primary-b2';
    const linkDecorator = variant === 'primary' ? 'always' : 'none';

    return (<>
        <div className={variant === 'primary' ? `terms-provider-sub` : `terms-provider-sub--secondary`}>
            <Typography type="meta-01" color={textColor}>
                {translateText(translate, "By searching you agree to these", t) + ' '}
                <LinkText as={<button type="button"></button>}
                    typographyType="meta-01"
                    color={linkColor}
                    decorator={linkDecorator}
                    onClick={toggleTermsModal}
                >
                    {translateText(translate, "Terms", t)}
                </LinkText>
            </Typography>
        </div>
        <Modal
            isOpen={termsModalOpen}
            backdrop="static"
            modalBody={translateText(translate, "We operate our provider referral service to assist patients in selecting providers who are members of Baylor Scott & White Quality Alliance. There are no charges to the providers or you for this service. Search results reflect all providers meeting the criteria you designate for your search. Your final selection of a provider should be based on your needs and preferences. If a provider leaves Baylor Scott & White Quality Alliance, we will no longer include the provider in our referral service. By using the provider referral service, you certify that you have received these disclosures." , t)}
            modalFooterButtons={[{
                variant: 'primary', label: translateText(translate, "Accept", t), onClick: toggleTermsModal
                }]} 
            toggle={toggleTermsModal}
            onCloseClick={toggleTermsModal}
        />
    </>);
}

export default withTranslation() (FindCareFormTerms);
